import React, { useEffect } from "react";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import { AuthLayout } from "../auth-layout/AuthLayout";
import styled from "styled-components";
import { CheckCircleOutlined } from "@ant-design/icons";

const { Title: AntTitle, Text } = Typography;

const VerificationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 40px 20px;
  text-align: center;
  color: #FEFFFC;
`;

const IconWrapper = styled.div`
  font-size: 80px;
  color: #EBFED1;
  margin-bottom: 8px;
`;

const StyledTitle = styled(AntTitle)`
  &.ant-typography {
    color: #FEFFFC !important;
    margin: 0 !important;
    font-size: 32px !important;
    font-weight: 600;
  }
`;

const Message = styled(Text)`
  font-size: 18px;
  color: #FEFFFC;
  opacity: 0.9;
  line-height: 1.6;
  max-width: 500px;
`;

const Subtitle = styled(Text)`
  font-size: 16px;
  color: #FEFFFC;
  opacity: 0.7;
  line-height: 1.5;
  max-width: 500px;
  margin-top: 8px;
`;

export const AccountDeleted: React.FC = () => {
    const { t } = useTranslation();

    useEffect(() => {
        // Clear all cookies and local storage
        document.cookie.split(";").forEach((c) => {
            document.cookie = c
                .replace(/^ +/, "")
                .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });
        localStorage.clear();
        sessionStorage.clear();
    }, []);

    return (
        <AuthLayout maxWidth={540}>
            <VerificationContainer>
                <IconWrapper>
                    <CheckCircleOutlined />
                </IconWrapper>
                <StyledTitle level={2}>{t("accountDeleted.title")}</StyledTitle>
                <Message>
                    {t("accountDeleted.message")}
                </Message>
                <Subtitle>
                    {t("accountDeleted.subtitle")}
                </Subtitle>
            </VerificationContainer>
        </AuthLayout>
    );
};
